import React, { useCallback, useMemo } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import BulletinNoDropdown from '../../../../components/common/BulletinNoDropdown';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { REPORT_FIELDS } from '../hook/useBulletinImplementationReportData';

const useBulletinImplementationReportFilter = ({ activeFilters, onFiltersChange }) => {
    const { th } = useLanguage();

    const statusOptions = useMemo(
        () => [
            { label: th('common.all'), value: null },
            { label: th('bulletinImplementationReport.status.applied'), value: 'Uygulandı' },
            { label: th('bulletinImplementationReport.status.notApplied'), value: 'Uygulanmadı' }
        ],
        [th]
    );

    const filters = useMemo(
        () =>
            REPORT_FIELDS.reduce(
                (result, { field, type }) => ({
                    ...result,
                    [field]: {
                        value: activeFilters?.[field] ?? null,
                        matchMode: activeFilters?.[`${field}MatchMode`] ?? (type === 'date' ? FilterMatchMode.DATE_IS : FilterMatchMode.CONTAINS)
                    }
                }),
                {}
            ),
        [activeFilters]
    );

    const onFilter = useCallback(
        (event) => {
            const nextFilters = { ...activeFilters };
            REPORT_FIELDS.forEach(({ field, type }) => {
                nextFilters[field] = event?.filters?.[field]?.value ?? null;
                nextFilters[`${field}MatchMode`] = event?.filters?.[field]?.matchMode ?? (type === 'date' ? FilterMatchMode.DATE_IS : FilterMatchMode.CONTAINS);
            });
            onFiltersChange(nextFilters);
        },
        [activeFilters, onFiltersChange]
    );

    const dateFilter = (options) => (
        <Calendar value={options.value ?? null} onChange={(event) => options.filterApplyCallback(event.value ?? null)} dateFormat="dd.mm.yy" placeholder={th('common.search')} className="p-column-filter w-full" showIcon showButtonBar />
    );

    const statusFilter = (options) => (
        <Dropdown value={options.value ?? null} options={statusOptions} onChange={(event) => options.filterApplyCallback(event.value)} placeholder={th('common.all')} className="p-column-filter w-full" showClear={false} />
    );

    const bulletinNoFilter = (options) => <BulletinNoDropdown value={options.value ?? null} onChange={(value) => options.filterApplyCallback(value)} placeholder={th('common.search')} className="p-column-filter w-full" />;

    const getColumnFilterProps = (field, type) => ({
        filter: true,
        filterField: field,
        filterPlaceholder: th('common.search'),
        showFilterMenu: false,
        showClearButton: false,
        filterElement: type === 'date' ? dateFilter : field === 'uygulanmaDurumu' ? statusFilter : field === 'bultenNo' ? bulletinNoFilter : undefined
    });

    return { filters, onFilter, getColumnFilterProps };
};

export default useBulletinImplementationReportFilter;
